// src/hooks/report/useManifestTrackingReport.js
import { useQuery, useInfiniteQuery } from '@tanstack/react-query';
import {
    fetchManifestTrackingSummary,
    fetchManifestsTracking,
    fetchManifestTrackingDetail,
    fetchManifestTrackingCatalogs,
} from '../../api/report/manifestTrackingReportApi';
import { PAGE_SIZE } from '../../utils/manifestTrackingReportConfig';

const cleanParams = (params = {}) =>
    Object.fromEntries(
        Object.entries(params).filter(([, v]) => v !== '' && v !== null && v !== undefined)
    );

export const useManifestTrackingSummary = (params = {}) => {
    const safeParams = cleanParams(params);
    return useQuery({
        queryKey: ['manifest-tracking-report', 'summary', safeParams],
        queryFn: () => fetchManifestTrackingSummary(safeParams),
        staleTime: 1000 * 60 * 5,
    });
};

export const useManifestsTracking = (params = {}) => {
    const safeParams = cleanParams(params);
    return useInfiniteQuery({
        queryKey: ['manifest-tracking-report', 'list', safeParams],
        queryFn: ({ pageParam = 0 }) =>
            fetchManifestsTracking({
                ...safeParams,
                limit: PAGE_SIZE,
                offset: pageParam,
            }),
        initialPageParam: 0,
        getNextPageParam: (lastPage) => {
            if (!lastPage) return undefined;
            const next = (lastPage.offset || 0) + (lastPage.limit || 0);
            return next < lastPage.total ? next : undefined;
        },
        staleTime: 1000 * 60 * 3,
    });
};

export const useManifestTrackingDetail = (manID, enabled = false) => {
    return useQuery({
        // Forzamos string para que 5 y "5" sean la MISMA key
        queryKey: ['manifest-tracking-report', 'detail', String(manID ?? '')],
        queryFn: () => fetchManifestTrackingDetail(manID),
        enabled: Boolean(manID) && enabled,
        // Sin cache: el detalle siempre debe ser fresco
        staleTime: 0,
        gcTime: 1000 * 60 * 5,
        // No intentar refrescar si no hay foco
        refetchOnWindowFocus: false,
    });
};

export const useManifestTrackingCatalogs = () => {
    return useQuery({
        queryKey: ['manifest-tracking-report', 'catalogs'],
        queryFn: fetchManifestTrackingCatalogs,
        staleTime: 1000 * 60 * 60,
    });
};